import React, { useCallback, useState } from 'react';
import { useMotionValue, useTransform } from 'framer-motion';
import { motion } from "../../Motion-polyfill";
import Visibility from '../../components/Visibility';
import { SubTitle, Image, renderLineBreak, Description } from '../../components/layouts';
import './style.scss';
import { buildImageURL, getTrack } from '../../helpers';


const isWebp = document.querySelector('html').classList.contains('webpSupport');

const IMAGES = {
  d: isWebp ? buildImageURL('/s14-1.webp') : buildImageURL('/s14-1.jpg'),
  m: isWebp ? buildImageURL('/s14-1-m.webp') : buildImageURL('/s14-1-m.jpg')
};

const track = getTrack({ block: 15 });

export function Portrait1({ m = false }) {
  const [mobile, setMobile] = useState(false);
  const progress = useMotionValue(0);
  const handleUpdate = useCallback(
    (e, { calculations: { percentagePassed, width } }) => {
      setMobile(width <= 750);
      progress.set(percentagePassed);
    },
    [progress, setMobile]
  );

  const o1 = useTransform(progress, [-0.5, 0], [0, 1]);
  const y1 = useTransform(progress, [-0.5, 0.2], ['200%', '-50%']);
  const y1m = useTransform(progress, [-0.5, 0.4], ['100%', '-50%']);

  const o2 = useTransform(progress, [0, 0.4], [0.2, 1]);
  const y2 = useTransform(progress, [0, 0.4], [10, 0]);
  const scale = useTransform(progress, [0, 0.4], [0.9, 1]);
  const scaleM = useTransform(progress, [0, 0.4], [0.8, 1]);

  const o3 = useTransform(progress, [0.125, 0.4], [0, 1]);
  // const y3 = useTransform(progress, [0.125, 0.4], ['25%', '0%']);
  const y3 = useTransform(progress, [0.125, 0.4], ['125%', '100%']);

  const imgStyle = mobile ? {} : { width: '50vw' };
  return (
    <Visibility offset={[-1000, 0]} onUpdate={handleUpdate} className="page-section section-portrait section-portrait-1 inverted" data-track={track}>
      <div className="sticky-content">
        <div className="section-content left" style={{ width: mobile ? 960 : '50vw' }}>
          <motion.div style={{ opacity: o1, y: mobile ? y1m : y1, width: '90%', margin: '0 auto' }}>
            <SubTitle>记录{renderLineBreak(mobile)}真实灿烂的你</SubTitle>
          </motion.div>
          {!m ? <motion.div style={{ opacity: o3, y: y3 }}>
            <Description className="small" style={{textAlign: 'center'}}>12M 专业人像镜头，实现面部的精细化调整，保留真实质感。</Description>
          </motion.div> : null}
          <motion.div className="picture left" style={{ opacity: o2, y: y2, scale: mobile ? scaleM : scale }}>
            <Image src={mobile ? IMAGES.m : IMAGES.d} className="s14-i-1" style={imgStyle} />
          </motion.div>
          {m ? <motion.div style={{ opacity: o3, y: y3 }}>
            <Description className="small left">12M 专业人像镜头，实现面部的精细化调整，保留真实质感。</Description>
          </motion.div> : null}
        </div>
      </div>
    </Visibility>
  );
}
